import React, { useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { bannersService } from '../../../../../shared/src/services/banners-service';
import { bannersActionIdsEnum, bannersActionTypesEnum } from '../../../../../shared/src/enums/banners.enum';
import { PnPDepositWidget } from '../../../../../shared/src/components/BannersCarousel/PnPDepositWidget';
import { BannerCta } from '../BannerCta';
import { AsgDictionaryContext, AsgFwContext } from '../../../../../verticals/src/contexts';

export const BannerCtaContainer = ({ ctaClassName, isPayNPlayEnabled, bannerAction }) => {
    const [depositAmount, setDepositAmount] = useState(0);
    const { platformReady } = useSelector(state => state.app);
    const AsgFW = useContext(AsgFwContext);
    const Dictionary = useContext(AsgDictionaryContext);
    const globals = { Dictionary, AsgFW };

    if (!platformReady) {
        return null;
    }

    const handlePnpDepositAmountClick = (value) => {
        setDepositAmount(parseInt(value));
    };

    const ctaClickHandler = () => {
        bannersService.linkOrWidgetHandler(
            depositAmount,
            globals,
            bannersActionTypesEnum.WIDGET,
            bannersActionIdsEnum.DEPOSIT,
        );
    };

    return (
        <>
            {isPayNPlayEnabled
                ? <PnPDepositWidget
                    changeAmountHandler={handlePnpDepositAmountClick}
                    globals={globals}
                    depositHandler={ctaClickHandler}
                />
                : <BannerCta
                    className={ctaClassName}
                    onClick={bannerAction}
                />}
        </>
    );
};
